const TestQuestionActionType = {
  FETCH_ALL_TESTQUESTION: "FETCH_ALL_TESTQUESTION",
  FETCH_SINGLE_TESTQUESTION: "FETCH_SINGLE_TESTQUESTION",
  ADD_TEST_QUESTION: "ADD_TEST_QUESTION",
  EDIT_TEST_QUESTION: "EDIT_TEST_QUESTION",
  DELETE_TEST_QUESTION: "DELETE_TEST_QUESTION",
};
export default TestQuestionActionType;
